import React from 'react';
import axios from 'axios';
import { Input, Form, Select, Col, Checkbox, message, Row } from 'antd';

import apiPath from 'apiPath';
import globalFormItemLayout from 'components/Portal/formItemLayout';
import withSpin from 'components/withSpin';
import SaveButton from 'components/SaveButton';


const formItemLayout = Object.assign({}, globalFormItemLayout);

const gradeLevels = [
    { key: 'FR', label: 'Freshman/1st year' },
    { key: 'SOPH', label: 'Sophomore/2nd year' },
    { key: 'JR', label: 'Junior/3rd year' },
    { key: 'SR', label: 'Senior/4th year +' },
    { key: 'PG', label: 'Post-Graduate' },
    { key: 'GAP', label: 'Pre-College Gap' }
];

class BasicInformation extends React.Component {

    state = {
        SRI_GRADE_LVL: null,
        SRI_REPEAT: null,
        ADMIT_GPA: null,
        UPDATED_GPA: null,
        repeatChecked: null,
        academicChecked: null,
        academicDisable: null,
        repeatDisable: null,
        gapChecked: null,
        gapNote: [],
    }

    //Okay this is hackey, BUT it checks to see if signatory statuses have been checked or not.  It then sets state accordingly and the checkboxes read whether its true or false in state then are checked or unchecked depending on the state
    getStatusesFromProps = (props) => {
        const statuses = props.statuses || {};
        this.setState({ SRI_GRADE_LVL: statuses.SRI_GRADE_LVL })
        if (statuses.SRI_REPEAT === "Y") {
            this.setState({ SRI_REPEAT: statuses.SRI_REPEAT, repeatChecked: true, repeatDisable: true })
        } else {
            this.setState({ SRI_REPEAT: false })
        }
    }

    //Post Admit GPA from input 
    postAdmitGPA = (values) => {
        axios.put(apiPath + '/admissions/postAdmitGpa', { ADMIT_GPA: values.ADMIT_GPA }, { withCredentials: true }).then(result => {
        })
        this.getGpa();
    }

    //Post Updated GPA from input 
    postUpdatedGPA = (values) => {
        axios.put(apiPath + '/admissions/postUpdatedGpa', { UPDATED_GPA: values.UPDATED_GPA }, { withCredentials: true }).then(result => {
        })
        this.getGpa();
    }

    //Get GPA values to insert into input form
    getGpa = () => {
        axios.get(apiPath + '/admissions/getGpa', { withCredentials: true }).then(result => {
            result.data.map(r => {
                this.setState({ ADMIT_GPA: r.admitGpa, UPDATED_GPA: r.updatedGpa })
            })
        })
    }

    postGapNote = (values) => {
        axios.put(apiPath + '/note/addGapNote', { note: values.note }, { withCredentials: true }).then(results => {
            this.setState({ gapNote: values.note })
        })
    }

    getGapNoteFromProps = (props) => {
        if (props.gapNote === null || props.gapNote === false) {
            this.setState({ gapNote: '' })
        } else {
            this.setState({ gapNote: props.gapNote })
        }
    }

    //This event handler only posts and gets GPA values
    handleSubmit = (event) => {
        event.preventDefault();
        this.props.isSubmitting();
        this.props.form.validateFields((err, values) => {
            const matchingRemark = this.props.remarks && this.props.remarks.find(remark => remark.Code === 'MAJOR');
            const data = Object.assign({}, values, (matchingRemark) ? { id: matchingRemark.AssignId } : {});
            axios({
                method: (matchingRemark && matchingRemark.AssignId) ? 'put' : 'post',
                url: apiPath + '/remark/31',
                data: data,
                withCredentials: true
            })
            this.postAdmitGPA(values);
            this.postUpdatedGPA(values);
            this.postGapNote(values);
            if (this.state.academicChecked === true) {
                this.updateAcademicPlan(event)
            }
            if (this.state.repeatChecked === true) {
                this.onRepeatChange(event)
                this.setState({ SRI_REPEAT: 'Y' })
            }
            this.postGradeLvl(event)
        })
        this.props.isSubmitted();
        message.success('Saved!');
        this.getGpa();
        this.getStatusesFromProps(this.props);
    }

    //Updates academic action plan STATUS so it will then appear in the student section.
    updateAcademicPlan = (event) => {
        axios.post(apiPath + '/admissions/enableActionPlanStatus', { status: "" }, { withCredentials: true }).then(result => {
            this.props.getActionPlan();
            this.setState({ academicDisable: true })
        })
    }

    getActionPlan = () => {
        axios.get(apiPath + '/admissions/getActionPlan', { withCredentials: true }).then(result => {
            if (result.data.status === null || result.data === false) {
                this.setState({ academicChecked: false, academicDisable: false })
            } else {
                this.setState({ academicChecked: true, academicDisable: true })
            }
        })
    }

    postGradeLvl = (event) => {
        this.props.form.validateFields((errors, values) => {
            axios.put(apiPath + '/statuses', { SRI_GRADE_LVL: values.SRI_GRADE_LVL }, { withCredentials: true }).then(response => {
                this.setState({ SRI_GRADE_LVL: values.SRI_GRADE_LVL });
            })
        })
    }

    onRepeatChange = (event) => {
        this.props.form.validateFields((errors, values) => {
            axios.put(apiPath + '/statuses', { SRI_REPEAT: 'Y' }, { withCredentials: true }).then(response => {
                this.setState({ repeatDisable: true });
            })
        })
    }

    academicChecked = (event) => {
        this.setState({ academicChecked: event.target.checked });
    }

    repeatChecked = (event) => {
        this.setState({ repeatChecked: event.target.checked });
    }

    gapChecked = (event) => {
        this.setState({ gapChecked: event.target.checked })
    }



    componentDidMount() {
        this.getStatusesFromProps(this.props);
        this.getGpa();
        this.getActionPlan();
        this.getGapNoteFromProps(this.props);

    }

    componentWillReceiveProps(nextProps) {
        this.getStatusesFromProps(nextProps);
        this.getGapNoteFromProps(nextProps);
    }

    render() {

        const { TextArea } = Input;
        const { getFieldDecorator, disabled } = this.props.form;
        const tailFormItemLayout = {
            wrapperCol: {
                xs: { span: 24, offset: 18 },
                sm: { span: 2, offset: 4 }
            }
        }

        const majorRemark = this.props.remarksLoaded && this.props.remarks.find(remark => remark.Code === 'MAJOR')
        const major = (typeof majorRemark === undefined || !majorRemark) ? '' : majorRemark.rmkString1

        let statusOptions = [
            {
                title: 'Conditional Admit',
                value: 'CA'
            },
            {
                title: 'Instant Admit',
                value: 'IA'
            },
            {
                title: 'Full Admit',
                value: 'FA'
            }
        ];


        return (
            <Form onSubmit={this.handleSubmit}>

                <div style={(this.props.isStudent && this.props.variant === "admin") ? { display: 'block' } : { display: 'none' }}>
                    <Form.Item label="School Name" {...formItemLayout}>
                        {getFieldDecorator('schoolName', {
                            initialValue: (this.props.agencyLoaded && this.props.agency.Name) ? this.props.agency.Name : ''
                        })(
                            <Input disabled style={{ width: 400 }} />
                        )}
                    </Form.Item>
                    <Form.Item label="Admitted GPA" {...formItemLayout} >
                        {getFieldDecorator('ADMIT_GPA', {
                            initialValue: this.state.ADMIT_GPA
                        })(
                            <Input disabled={this.state.ADMIT_GPA !== null} style={{ width: 400 }} />
                        )}
                    </Form.Item>
                    <Form.Item label="Updated GPA" {...formItemLayout} >
                        {getFieldDecorator('UPDATED_GPA', {
                            initialValue: this.state.UPDATED_GPA
                        })(
                            <Input disabled={this.state.UPDATED_GPA !== null} style={{ width: 400 }} />
                        )}
                    </Form.Item>
                    <Form.Item label="Student Type" {...formItemLayout} >
                        {getFieldDecorator('Student Type', {
                            initialValue: (this.props.agency === null || undefined) ? '' :
                                (this.props.agency.Name === "GAP" || this.props.agency.Name === "Post-Graduate") ? this.props.agency.Name : "TRAD"
                        })(
                            <Input disabled={true} style={{ width: 400 }} />
                        )}
                    </Form.Item>
                    <Form.Item label="Major" {...formItemLayout} >
                        {getFieldDecorator('Major', {
                            initialValue: major
                        })(
                            <Input disabled={disabled} type="Major" style={{ width: 400 }} />

                        )}
                    </Form.Item>
                    <Form.Item label="Grade Level for Voyage" {...formItemLayout}>
                        {getFieldDecorator('SRI_GRADE_LVL', {
                            initialValue: this.state.SRI_GRADE_LVL,
                        })(
                            <Select style={{ width: 400 }}>
                                {gradeLevels.map(grade => {
                                    return <Select.Option key={grade.key}>{grade.label}</Select.Option>
                                })}
                            </Select>
                        )}
                    </Form.Item>
                    <Form.Item label="Academic Action Plan" {...formItemLayout}>
                        {getFieldDecorator('AcademicActionPlan', {
                            initialValue: this.state.academicChecked
                        })(
                            <Checkbox checked={this.state.academicChecked} disabled={this.state.academicDisable} onChange={this.academicChecked}>Require Plan</Checkbox>
                        )}
                    </Form.Item>
                    <Form.Item label="Is this student a:" {...formItemLayout}>
                        {getFieldDecorator('SRI_REPEAT', {
                            initialValue: this.state.SRI_REPEAT
                        })(
                            <Checkbox checked={this.state.repeatChecked} disabled={this.state.repeatDisable} onChange={this.repeatChecked}>Repeat Voyager</Checkbox>
                        )}
                    </Form.Item>
                    <Form.Item label="Enter Gap Year Note Here"{...formItemLayout}>
                        {getFieldDecorator('note', {
                            initialValue: (this.state.gapNote.GN_NOTE === undefined || this.state.gapNote.GN_NOTE === null) ? '' : this.state.gapNote.GN_NOTE
                        })(
                            <TextArea style={{ width: 400 }} />
                        )}
                    </Form.Item>
                    <Form.Item {...tailFormItemLayout}>
                        <SaveButton   
                            loading={this.props.getStatus().submitting} />
                    </Form.Item>
                </div>
            </Form>
        );
    }
}

export default withSpin(Form.create()(BasicInformation));


// WEBPACK FOOTER //
// ./portal-components/Portal/Admissions/BasicInformation.jsx